import report from './report';
// import user from './user'

export default {
  checklist: {
    namespaced: true,
    modules: {
      report
      // user
    }
  }
};
